/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TrendsChartRequestDTO { 
    /**
     * Measured client identifier
     */
    clientId: number;
    /**
     * Brand identifier within the client
     */
    brandId: number;
    /**
     * Metric view type: \'ROAS\' for return-on-ad-spend metrics, \'CPO\' for cost-per-order metrics
     */
    viewBy: TrendsChartRequestDTO.ViewByEnum;
    /**
     * Metric to plot on the chart. Values include: roasI (incremental ROAS), cpoI (incremental cost per order), adjustmentFactor, spend, ordersLT (lifetime orders), salesLT (lifetime sales), ordersI (incremental orders), salesI (incremental sales), percOrdersI (percent incremental orders), percSalesI (percent incremental sales)
     */
    chartViewBy: TrendsChartRequestDTO.ChartViewByEnum;
    /**
     * Conversion event type. Must match a value from the layout endpoint.
     */
    conversionType: string;
    /**
     * Time resolution for chart data points
     */
    resolution: TrendsChartRequestDTO.ResolutionEnum;
    /**
     * Relative day label for the analysis period (e.g. \'latest30\', \'latest90\')
     */
    relativeDay: string;
    /**
     * Analysis period start date in ISO-8601 format
     */
    dateStart: string;
    /**
     * Analysis period end date in ISO-8601 format
     */
    dateStop: string;
    /**
     * Optional segment filter values
     */
    segments?: Array<string>;
    /**
     * Optional channel filter values
     */
    channels?: Array<string>;
    /**
     * Optional tactic filter values
     */
    tactics?: Array<string>;
    /**
     * Whether to use the client\'s fiscal calendar for time bucketing
     */
    isFiscalCalendarEnabled?: boolean;
}
export namespace TrendsChartRequestDTO {
    export type ViewByEnum = 'ROAS' | 'CPO';
    export const ViewByEnum = {
        Roas: 'ROAS' as ViewByEnum,
        Cpo: 'CPO' as ViewByEnum
    };
    export type ChartViewByEnum = 'roasI' | 'cpoI' | 'adjustmentFactor' | 'spend' | 'ordersLT' | 'salesLT' | 'ordersI' | 'salesI' | 'percOrdersI' | 'percSalesI';
    export const ChartViewByEnum = {
        RoasI: 'roasI' as ChartViewByEnum,
        CpoI: 'cpoI' as ChartViewByEnum,
        AdjustmentFactor: 'adjustmentFactor' as ChartViewByEnum,
        Spend: 'spend' as ChartViewByEnum,
        OrdersLt: 'ordersLT' as ChartViewByEnum,
        SalesLt: 'salesLT' as ChartViewByEnum,
        OrdersI: 'ordersI' as ChartViewByEnum,
        SalesI: 'salesI' as ChartViewByEnum,
        PercOrdersI: 'percOrdersI' as ChartViewByEnum,
        PercSalesI: 'percSalesI' as ChartViewByEnum
    };
    export type ResolutionEnum = 'year' | 'month' | 'week' | 'day';
    export const ResolutionEnum = {
        Year: 'year' as ResolutionEnum,
        Month: 'month' as ResolutionEnum,
        Week: 'week' as ResolutionEnum,
        Day: 'day' as ResolutionEnum
    };
}


